import Collaboration from "../components/Collaboration";
import PageTitle from "../components/PageTitle";

import { useRouteError } from "react-router-dom";
import Button from "../components/Button";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <>
      <PageTitle title={"Contact"} path={["Pages", "Contact Us"]} />
      <div className=" max-w-5xl mx-auto flex flex-col items-center">
        <img
          alt="page you requested was not found"
          src={require("../assets/error-page/img01.png")}
        />
        <Button color={"pink"}>Back To Home</Button>
      </div>
      <Collaboration />
    </>
  );
}
